import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "../../assetes/css/common.css";
// import ChatIcon from '@mui/icons-material/Chat';

interface MenuItem {
  p_Description: string;
  p_MenuId: any;
  p_MenuName: string;
  p_Url: any;
  p_MenuIcon: any;
}

const Sidebar: React.FC = () => {
  const location = useLocation();
  const currentURL = location.pathname;
  const navigate = useNavigate();
  const [menuItemsList, setMenuItemList] = useState<MenuItem[]>([]);

  useEffect(() => {
    const sideBarMenu = localStorage.getItem("user");
    if (sideBarMenu !== null) {
      const userData = JSON.parse(sideBarMenu);
      const menuItemList = userData.menuDetailsResponses;
      setMenuItemList(menuItemList);
    }
  }, []);

  const items = menuItemsList?.map((menuItem) => ({
    icon: menuItem.p_MenuIcon,
    label: menuItem.p_MenuName,
    url: menuItem.p_Url,
    command: () => {
      navigate(menuItem.p_Url);
    },
  }));

  return (
    <div className="sidebar">
      <ul>
        {items?.map((menuItem, index) => {
          return (
            <li
              key={index}
              className={currentURL === menuItem.url ? "active" : ""}
            >
              <Link to={menuItem.url}>
                <div className={`${menuItem.icon}`} />
                <span>{menuItem.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Sidebar;
